import React, { useState, useEffect, forwardRef } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import axiosInstance from "../api/axios";

const EmploymentCertificate = forwardRef((props, ref) => {
  const [user, setUser] = useState({
    nameKor: "",
    birthDate: "",
    address: "",
    position: "",
    employmentPeriod: "",
  });
  const [error, setError] = useState("");

  const today = new Date();
  const formattedDate = `${today.getFullYear()}년 ${
    today.getMonth() + 1
  }월 ${today.getDate()}일`;

  const sealImage = "/images/seal/seal.png";

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axiosInstance.get("/api/user/detail"); // axiosInstance 사용
        const userData = response.data.data;

        // `userData.createdAt` 포맷 (월까지만)
        const createdAtDate = new Date(userData.createdAt);
        const formattedCreatedAt = `${createdAtDate.getFullYear()}년 ${
          createdAtDate.getMonth() + 1
        }월`;

        setUser({
          userId: userData.userId,
          nameKor: userData.nameKor,
          birthDate: userData.birthDate,
          address: userData.address,
          position: userData.position,
          employmentPeriod: `${formattedCreatedAt} ~ 현재`,
        });
      } catch (err) {
        console.error("Failed to load user data:", err);
        setError("사용자 정보를 가져오는데 실패했습니다.");
      }
    };

    fetchUserData();
  }, []);

  return (
    <div
      ref={ref}
      style={{
        maxWidth: "210mm", // A4 용지 크기
        margin: "0 auto",
        padding: "20px",
        border: "1px solid #ddd", // 기본 테두리
        fontFamily: "'Nanum Gothic', sans-serif",
        fontSize: "12pt",
        color: "black",
        lineHeight: "1.5",
      }}
      className="certificate-container"
    >
      {error && <Alert variant="danger">{error}</Alert>}
      <Container fluid>
        <Row className="mb-4">
          <Col>
            <h3 className="text-center">재직증명서</h3>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={4}>
            <strong>성명:</strong>
          </Col>
          <Col>{user?.nameKor || "N/A"}</Col>
        </Row>

        <Row className="mb-3">
          <Col xs={4}>
            <strong>생년월일:</strong>
          </Col>
          <Col>{user?.birthDate || "N/A"}</Col>
        </Row>

        <Row className="mb-3">
          <Col xs={4}>
            <strong>주소:</strong>
          </Col>
          <Col>{user?.address || "N/A"}</Col>
        </Row>

        <Row className="mb-3">
          <Col xs={4}>
            <strong>직위:</strong>
          </Col>
          <Col>{user?.position || "N/A"}</Col>
        </Row>

        <Row className="mb-3">
          <Col xs={4}>
            <strong>재직기간:</strong>
          </Col>
          <Col>{user?.employmentPeriod || "N/A"}</Col>
        </Row>

        <Row className="my-4">
          <Col>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <p
              className="text-center"
              style={{
                color: "black",
              }}
            >
              위와 같이 재직하고 있음을 증명합니다.
            </p>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <br></br>
            <br></br>
            <br></br>
            <p
              className="text-end"
              style={{
                color: "black",
              }}
            >
              {formattedDate}
            </p>
          </Col>
        </Row>

        <Row>
          <Col>
            <p
              className="text-end"
              style={{
                color: "black",
              }}
            >
              <strong>사단법인 한국관광산업포럼 이사장</strong>
              <br />
              <span style={{ position: "relative", display: "inline-block" }}>
                <strong
                  style={{
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  윤대순
                </strong>
                <img
                  src={sealImage}
                  alt="Seal"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "90%",
                    transform: "translateX(-50%)",
                    width: "30px",
                    height: "30px",
                    zIndex: 1,
                  }}
                />
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
});

export default EmploymentCertificate;
